import { Store } from '@ngxs/store';
import { AccessState } from '../../access/access/access.state';
import { CLIENT_CACHE_PROTOCOL, CLIENT_CACHE_TAG_USERCHANGE } from '../client-cache';
import { ClientCacheService } from '../client-cache.service';
import { distinctUntilChanged } from 'rxjs';
import { takeWhileAlive } from '../../utils';
import { ConfigService } from '@core/shared/config';
import { ProtocolDistributor } from '@core/shared/protocol';
import * as i0 from "@angular/core";
import * as i1 from "../client-cache.service";
import * as i2 from "@ngxs/store";
import * as i3 from "@core/shared/config";
import * as i4 from "@core/shared/protocol";
export let ClientCacheAccessConnector = /*#__PURE__*/(() => {
  class ClientCacheAccessConnector {
    constructor(clientCache, store, config, protocol) {
      const isAdmin = config.isPlatform('admin');
      store.select(AccessState.abilities).pipe(distinctUntilChanged(), takeWhileAlive()).subscribe(abilities => {
        if (isAdmin) {
          clientCache.clearCache();
          protocol.write('abilities changed. cleared all cache entries of [platform:admin]');
        } else {
          const count = clientCache.clearCacheByTag(CLIENT_CACHE_TAG_USERCHANGE);
          protocol.write('abilities changed. cleared ' + count + ' cache entries of [platform:frontend]');
        }
      });
    }
    static {
      this.ɵfac = function ClientCacheAccessConnector_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ClientCacheAccessConnector)(i0.ɵɵinject(i1.ClientCacheService), i0.ɵɵinject(i2.Store), i0.ɵɵinject(i3.ConfigService), i0.ɵɵinject(CLIENT_CACHE_PROTOCOL));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: ClientCacheAccessConnector,
        factory: ClientCacheAccessConnector.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return ClientCacheAccessConnector;
})();